import { getIvaRateVenta, normalizarTipoIvaReceptor } from '../../../utils/getIvaRateVenta';

const TIPOS_IVA_PRECIOS_CON_IVA = new Set(['C', 'N', 'E']);

export const round2 = (value: number): number => Math.round(value * 100) / 100;

export const aplicarPorcentajeDescuento = (base: number, porcDesc: number): number => {
  const baseCents = Math.round((Number(base) || 0) * 100);
  const porc = Number(porcDesc) || 0;
  if (!Number.isFinite(porc) || porc === 0) return baseCents / 100;
  const descCents = Math.round((baseCents * porc) / 100);
  return (baseCents - descCents) / 100;
};

export const esTipoIvaPreciosConIva = (tipoIva?: string | null): boolean => {
  const tipo = normalizarTipoIvaReceptor(tipoIva);
  return TIPOS_IVA_PRECIOS_CON_IVA.has(tipo);
};

export const multiplicadorIvaProducto = (
  producto: unknown,
  tipoIva?: string | null,
  condIvaEmisor?: string | null,
): number => {
  const ivaRate = getIvaRateVenta(producto, normalizarTipoIvaReceptor(tipoIva), condIvaEmisor);
  return 1 + (Number.isFinite(ivaRate) && ivaRate > 0 ? ivaRate : 0);
};

export const aPrecioDisplay = (precioNeto: number, multiplicador: number): number => {
  const precio = Number(precioNeto) || 0;
  const mult = Number(multiplicador) > 0 ? Number(multiplicador) : 1;
  return round2(precio * mult);
};

export const aPrecioNeto = (precioDisplay: number, multiplicador: number): number => {
  const precio = Number(precioDisplay) || 0;
  const mult = Number(multiplicador) > 0 ? Number(multiplicador) : 1;
  return round2(precio / mult);
};

export const subtotalLineaDisplay = (subtotalNeto: number, multiplicador: number): number =>
  aPrecioDisplay(subtotalNeto, multiplicador);

/** Subtotal con IVA: el % se aplica sobre el precio final visible, no sobre el neto redondeado. */
export const subtotalLineaConIvaDisplay = (
  precioNeto: number,
  cantidad: number,
  descuentoPct: number,
  multiplicador: number,
): number => {
  const precioDisplay = aPrecioDisplay(precioNeto, multiplicador);
  const brutoDisplay = round2(precioDisplay * (Number(cantidad) || 0));
  return aplicarPorcentajeDescuento(brutoDisplay, descuentoPct);
};
